import React from 'react'

export const TextAddComments = ({ onClick, children, disable = false }) => {
    return (
        <div className='flex flex-end'>
            <p
                onClick={() => {
                    if (disable) return
                    onClick()
                }}
                className={`text-[10px] ${disable ? 'text-[#9A9A9A] cursor-no-drop' : 'text-primaryTwo cursor-pointer'}`}>
                {children}
            </p>
        </div>
    )
}
